import React, { Component } from "react";
import { Link } from "react-router-dom";
import { inject, observer } from 'mobx-react';
import PartnerManagementStore from '../../stores/PartnerManagementStore';

@inject('PartnerManagementStore', 'UserStore')
@observer
class RiderManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      selectedRiderId: null,
      showDeleteConfirm: false
    };
  }

  componentDidMount = () => {
    document.body.classList.add('partner-management-horizontal-scroll');
    PartnerManagementStore.removeRiderid();
  }

  componentWillUnmount = () => {
    document.body.classList.remove('partner-management-horizontal-scroll');
  }

  handleSearch = () => {
    PartnerManagementStore.handleGetRiders(this.state.searchText);
  };

  handleSort = (field) => {
    // TODO: Add sorting
  };

  confirmEdit = (riderId) => {
    PartnerManagementStore.setRiderid(riderId);
  };

  confirmDelete = (riderId) => {
    this.setState({ selectedRiderId: riderId, showDeleteConfirm: true });
  };

  doDeleteRider = () => {
    PartnerManagementStore.doDeleteRider(this.state.selectedRiderId);
    this.setState({ showDeleteConfirm: false });
  };

  render() {
    const { searchText, showDeleteConfirm } = this.state;

    const {
        PartnerManagementStore: { riderList }
    } = this.props;

    return (
      <div id="content">
        <section id="widget-grid" className="partner-management__list-page">
          <div className="row">
            <article className="col-sm-12">
              <fieldset className="partner-management__search-bar d-flex flex-wrap mb-3">
                <div className="partner-management__search-input-wrap col-sm-6">
                  <input
                    className='partner-management__search-input border--rounded border--solid fs--medium-medium-large text--center text--black text--bolder center--horizontal ps'
                    placeholder="Search Rider by Name or Email ID..."
                    type="text"
                    value={searchText}
                    onChange={(e) => this.setState({ searchText: e.target.value })}
                    onKeyPress={(e) => e.key === "Enter" && this.handleSearch()}
                  />
                </div>
                <div className="partner-management__search-action col-sm-4">
                  <button className="partner-management__search-button btn btn-primary" onClick={this.handleSearch}>Search</button>
                </div>
                <div className="partner-management__search-action col-sm-2">
                    <Link to="/partner-management/edit-partner">
                        <button className="partner-management__search-button btn btn-primary">
                            <i className="fa-fw fa fa-plus" /> Add
                        </button>
                  </Link>
                </div>
              </fieldset>

                {riderList ? 
                    (riderList.length === 0 ? (
                    <div className="col-lg-12 mtm">
                        <h3>No results :(</h3>
                    </div>
                ) : (
                    <div className="partner-management__table-scroll">
                    <table className="partner-management__results-table table table-striped table-bordered table-responsive mtm">
                    <thead>
                        <tr>
                        {["name", "email", "mobileno", "role", "created_date"].map((field, idx) => (
                            <th key={idx} onClick={() => this.handleSort(field)} style={{ cursor: "pointer" }}>
                            {field.replace("_", " ").toUpperCase()}
                            </th>
                        ))}
                        <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {riderList.map((rider) => (
                        <tr key={rider.id}>
                            <td style={{ verticalAlign: 'middle' }}>{rider.firstname} {rider.lastname}</td>
                            <td style={{ verticalAlign: 'middle' }}>{rider.email}</td>
                            <td style={{ verticalAlign: 'middle' }}>{rider.mobileno}</td>
                            <td style={{ verticalAlign: 'middle' }}>{rider.role}</td>
                            <td style={{ verticalAlign: 'middle' }}>{new Date(rider.created_date).toLocaleString()}</td>
                            <td style={{ verticalAlign: 'middle' }}>
                            <Link to={`/partner-management/edit-partner`}>
                                <button className="btn btn-primary mrm" onClick={() => this.confirmEdit(rider.id)}
                                    style={{fontSize: '12px', padding: '9px 12px'}}>
                                    <i className="fa-fw fa fa-edit" /> Edit
                                </button>
                            </Link>
                            <button className="btn btn-danger" onClick={() => this.confirmDelete(rider.id)}
                                style={{fontSize: '12px', padding: '9px 12px'}}>
                                Delete
                            </button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                    </div>
                )) : (
                    <div className="col-lg-12 mtm">
                        <h3>Waiting for your search input...</h3>
                    </div>
                )}
            </article>
          </div>
        </section>

        {showDeleteConfirm && (
          <div className="modal d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title">Confirmation</h1>
                  <button className="close" onClick={() => this.setState({ showDeleteConfirm: false })} style={{position: 'absolute', right: 0, top: 0}}><span>&times;</span></button>
                </div>
                <div className="modal-body mtm">
                  <h3>Are you sure you want to delete this record?</h3>
                </div>
                <div className="modal-footer mtm">
                  <button className="btn btn-success mrm" onClick={this.doDeleteRider}>Yes</button>
                  <button className="btn btn-primary" onClick={() => this.setState({ showDeleteConfirm: false })}>No</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RiderManagement;
